import { FC } from "react";
import { CommunicationField, User } from "../../../types";
import Scrollbar from "../../Common/Scrollbar";
import MainNav from "../MainNav";
import { StyledSidebar, StyledBody } from "./style";

type Props = {
  communicationsFields: CommunicationField[];
  activeField: string | "inbox" | null;
  isInternalUser: boolean | undefined;
  companyUsers: User[];
  onUserChange: (event: React.ChangeEvent) => any;
};

const Sidebar: FC<Props> = ({
  communicationsFields,
  activeField,
  isInternalUser,
  companyUsers,
  onUserChange,
}) => {
  return (
    <StyledSidebar className="sidebar">
      <Scrollbar top="0px">
        <StyledBody>
          <MainNav
            communicationsFields={communicationsFields}
            activeField={activeField}
            isInternalUser={isInternalUser}
            companyUsers={companyUsers}
            onUserChange={onUserChange}
          />
        </StyledBody>
      </Scrollbar>
    </StyledSidebar>
  );
};

export default Sidebar;
